module.exports = __webpack_public_path__ + "img/Truppführer_W.42937739.svg";